import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const ArtworksBlock = ({ products, ...props }) => (
    <ThumbnailsBlock thumbnails={products} {...props} />
)